module.exports = __webpack_public_path__ + "img/03.102d2203.png";